<template>
  <div>
        <div class="block-content">
        

        <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
            <h3 class="font-w300 push-10">{{ sectionLabelCreateMasterApiKey[actualLanguage] }}</h3>
          
            <div class="form-group">
                <div class="col-xs-12">
                    <label for="register4-firstname">{{ labelApiKeyReferenceName[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="referenceName" placeholder="Reference">
                </div>
            </div>

            <div class="form-group">
                <div class="col-xs-4">
                    <label for="register4-firstname">{{ labelTextBoxMaxCost[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="maximumMonthlyCost" placeholder="Adresse / Address...">
                </div>
            </div>





            


            <div class="form-group">
              <div class="col-sm-12 col-md-12">
                <div>
                    <p><button @click="saveOrganization()" type="button" class="btn btn-block btn-success" name="button">
                      <spinner size="small" v-if="keyIsCreating"></spinner>
                      <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-industry fa-1x push-5-r "></i>{{ buttonLabelSave[actualLanguage] }}</span></button></p>
                </div> 
              </div>
            </div>
          

          </form>
        </div>




  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'AddOrganizationForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      keyIsCreating: false,


      actualLanguage : "FR",
      referenceName : "",
      maximumMonthlyCost:"50",

      sectionLabelCreateMasterApiKey:{FR: "Création clef d'API maître", EN: 'Create API master key'},
      labelApiKeyReferenceName:{FR: "Nom de référence de la clef", EN: 'Key reference name'},
      labelTextBoxMaxCost:{FR: "Limite coût mensuel", EN: 'Maximum monthly cost'},

      buttonLabelSave:{FR: "Créer la clef", EN: 'Create key'},


    }
  },

  methods: {

    saveOrganization() {
      this.keyIsCreating = true



        var requestData = { 'postAction':'CreateNewOrganizationMasterKey',
                            'organizationId': this.overlayParameters.actualOrganizationId,
                            'referenceName':this.referenceName,
                            'maximumMonthlyCost':this.maximumMonthlyCost
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log(response.data)
              this.keyIsCreating = false
            if(response.data.Code=='OK'){
                this.$store.dispatch('sessionStore/refreshProfileData')
                this.$store.dispatch('overlayStore/toggleModal',false)
                window.alert("The organisation will be refreshed")
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })       
      }

  
  },

  computed: {
    ...mapState('sessionStore', ['profileData']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //console.log('-----Profile Data----')
    //console.log(this.profileData)



  }


}
</script>



// WEBPACK FOOTER //
// OrganizationApiAddMasterKeyForm.vue?06e5b7dd